export default __webpack_public_path__ + "b1d47b7fabc114676c6a02db05fb49c5.png";